export const mockPosts = [
  {
    id: 'post-1',
    authorId: 'expert-2',
    spaceId: 'space-1',
    body: 'For a 20MWh system on a weak grid node, are people specifying grid-forming inverters in the tender, or handling it as a separate workstream? Trying not to over-scope the RFP.',
    attachedResourceId: 'res-3',
    createdAt: '2026-06-10T14:30:00Z',
    replies: [
      {
        id: 'reply-1',
        authorId: null,
        isAIDraft: true,
        pendingExpertReview: true,
        body: 'Most GOTF tenders on weak nodes specify grid-forming capability inline — see §4.2 of the model tender. Two peers handled exactly this: the Kenya BESS showcase and Lerato Mokoena (below). Want me to introduce you?'
      }
    ]
  },
  {
    id: 'post-2',
    authorId: 'user-2',
    spaceId: 'space-5',
    body: 'Looking for bankable grid-scale storage projects in East Africa, >10MWh, with utility offtake. Which showcases are open for co-investment?',
    createdAt: '2026-06-09T11:20:00Z',
    replies: []
  }
];
